import {FC, useState, useEffect, Fragment} from 'react'

import {useNavigate} from 'react-router-dom'

type Props = {
  to: string
}

const BackButtonContent: FC<Props> = ({to}) => {
  const navigate = useNavigate()
  return (
    <div
      className='card p-4 border-0 shadow-sm rounded-4'
      style={{cursor: 'pointer'}}
      onClick={() => navigate(to)}
    >
      <div className='d-flex align-items-center gap-2 ml-4'>
        <i className='fa fa-arrow-left' style={{color: '#6c757d'}} />
        <span className='fw-semibold text-dark'>Kembali</span>
      </div>
    </div>
  )
}

const BackButton: FC<Props> = ({to}) => {
  return <BackButtonContent to={to} />
}

export default BackButton
